export default function Positioning() {
  return (
    <section className="py-32 bg-white">
      <div className="max-w-[1200px] mx-auto px-20">
        <div className="grid grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block px-4 py-2 bg-blue-50 rounded-full mb-6">
              <span className="text-sm font-medium text-blue-600">Our Philosophy</span>
            </div>

            <h2 className="text-5xl font-semibold text-slate-900 mb-8 leading-tight">
              AI Doesn't Need to Be Overwhelming
            </h2>

            <div className="space-y-6">
              <p className="text-xl text-slate-600 leading-relaxed">
                For many organizations, artificial intelligence feels complex, risky, or unclear.
                We act as your North Star — providing strategic direction, structured implementation, and long-term system architecture that aligns with your operational goals.
              </p>

              <p className="text-xl text-slate-600 leading-relaxed">
                We don't sell tools.
              </p>

              <p className="text-2xl font-semibold text-slate-900">
                We design intelligent systems that work.
              </p>
            </div>
          </div>

          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/4a2391dd7e790f5cafcc10a6ee81eeb8.jpg"
              alt="AI System Visualization"
              className="w-full h-[700px] object-cover rounded-2xl shadow-2xl"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/20 to-transparent rounded-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
